"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useOpenProjectAnalytics = exports.getOpenProjectAnalyticsFunction = void 0;
var inversify_react_1 = require("inversify-react");
var FeatureFlag_1 = __importDefault(require("@CommonFrontendBackend/FeatureFlag"));
function getOpenProjectAnalyticsFunction(usingFeature, goToProjectAction, serverTelemetry, upseller, topLevelRoute) {
    var openProjectAnalytics = function (projectStore, eventOrigin) {
        if (usingFeature(FeatureFlag_1.default.BasicAnalytics)) {
            goToProjectAction("analytics", projectStore, topLevelRoute);
        }
        else {
            return upseller.upsell({
                feature: "basic analytics",
                featureLabel: "Analytics",
                customUpsellMessage: "Learn what your clients care about with detailed information they viewed & clicked.",
                customUpsellVideoLink: "https://www.youtube.com/watch?v=J63WpPlzI_g",
                customUpsellHelpLink: "https://help.qwilr.com/article/156-analytics-insights",
            });
        }
    };
    return openProjectAnalytics;
}
exports.getOpenProjectAnalyticsFunction = getOpenProjectAnalyticsFunction;
function useOpenProjectAnalytics(topLevelRoute) {
    var usingFeature = (0, inversify_react_1.useInjection)("usingFeature");
    var state = (0, inversify_react_1.useInjection)("state");
    var serverTelemetry = (0, inversify_react_1.useInjection)("serverTelemetry");
    var upseller = (0, inversify_react_1.useInjection)("upseller");
    var openProjectAnalytics = getOpenProjectAnalyticsFunction(usingFeature, state.goToProjectAction, serverTelemetry, upseller, topLevelRoute);
    return openProjectAnalytics;
}
exports.useOpenProjectAnalytics = useOpenProjectAnalytics;
